// extracted by mini-css-extract-plugin
export default {"napsaLog-header":"Header_napsaLog-header__rFzAa","napsaLog-header-item":"Header_napsaLog-header-item__a9WcT"};